import React from "react";
import {
  LuScissors,
  LuStar,
  LuHeart,
  LuSparkles,
  LuZap,
  LuMusic,
  LuCamera,
  LuLeaf,
  LuUser,
  LuBriefcase,
  LuLayoutDashboard,
  LuFileText,
  LuUsers,
  LuClock,
  LuImage,
  LuBanknote,
  LuLayoutGrid,
  LuBuilding2,
  LuSlidersHorizontal,
  LuSettings,
  LuTag,
  LuUserCircle,
  LuCalendarClock,
  LuCalendar,
  LuFlaskConical,
  LuShieldCheck,
  LuStethoscope,
  LuPill,
  LuHeartPulse,
  LuSyringe,
  LuDroplets,
  LuScanFace,
  LuSparkle,
  LuSun,
  LuBrush,
  LuGem,
  LuLanguages,
} from "react-icons/lu";

export const DEFAULT_CATEGORY_ICON = "LuStar";

export const CATEGORY_ICON_OPTIONS = [
  "LuLayoutDashboard",
  "LuFileText",
  "LuUsers",
  "LuClock",
  "LuImage",
  "LuBanknote",
  "LuLayoutGrid",
  "LuBuilding2",
  "LuSlidersHorizontal",
  "LuSettings",
  "LuTag",
  "LuUserCircle",
  "LuScissors",
  "LuStar",
  "LuHeart",
  "LuSparkles",
  "LuZap",
  "LuMusic",
  "LuCamera",
  "LuLeaf",
  "LuUser",
  "LuBriefcase",
  "LuStethoscope",
  "LuPill",
  "LuHeartPulse",
  "LuSyringe",
  "LuDroplets",
  "LuScanFace",
  "LuSparkle",
  "LuSun",
  "LuBrush",
  "LuGem",
  "LuLanguages",
];

export const CATEGORY_ICON_MAP = {
  LuScissors,
  LuStar,
  LuHeart,
  LuSparkles,
  LuZap,
  LuMusic,
  LuCamera,
  LuLeaf,
  LuUser,
  LuBriefcase,
  LuLayoutDashboard,
  LuFileText,
  LuUsers,
  LuClock,
  LuImage,
  LuBanknote,
  LuLayoutGrid,
  LuBuilding2,
  LuSlidersHorizontal,
  LuSettings,
  LuTag,
  LuUserCircle,
  LuCalendarClock,
  LuCalendar,
  LuFlaskConical,
  LuShieldCheck,
  LuStethoscope,
  LuPill,
  LuHeartPulse,
  LuSyringe,
  LuDroplets,
  LuScanFace,
  LuSparkle,
  LuSun,
  LuBrush,
  LuGem,
  LuLanguages,
};

const CATEGORY_IMAGE_EXT_RE = /\.(svg|png|jpe?g|webp|gif|avif)$/i;

export function getCategoryImageSrc(icon) {
  if (typeof icon !== "string") return null;

  const value = icon.trim();
  if (!value) return null;

  if (/^(https?:\/\/|data:image\/|\/)/i.test(value)) return value;
  if (CATEGORY_IMAGE_EXT_RE.test(value)) return `/assets/category-icons/${value}`;

  return null;
}

export function renderCategoryIcon(icon, { size = 16 } = {}) {
  const imageSrc = getCategoryImageSrc(icon);

  if (imageSrc) {
    return (
      <img
        src={imageSrc}
        alt=""
        width={size}
        height={size}
        style={{
          width: size,
          height: size,
          objectFit: "contain",
          display: "block",
        }}
      />
    );
  }

  const IconComponent =
    CATEGORY_ICON_MAP[icon] || CATEGORY_ICON_MAP[DEFAULT_CATEGORY_ICON];

  return <IconComponent size={size} />;
}
